/* eslint-disable no-unused-vars */
export const enum ActiveStates {
  Active = 'active',
  Hidden = 'hidden',
}
